import { useQuery } from '@apollo/client/react/hooks'
import { PayrollIssuesPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollIssuesTable from 'modules/payroll_bundle/components/PayrollIssuesTable'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'

const PayrollIssuesPage = () => {
  const { currentPeriod } = usePolicyPeriods()

  const { loading: loadingIssues, data } = useQuery(PayrollIssuesPageDocument, {
    variables: {
      policyPeriodId: currentPeriod?.id ?? 0,
    },
    fetchPolicy: 'cache-first',
    skip: !currentPeriod,
  })

  // This situation is resolved by the PayrollManagementPage so we can ignore it here.
  if (!currentPeriod) return null

  return (
    <ResponsivePage.Body>
      <PayrollIssuesTable
        loading={loadingIssues}
        payrollIssues={data?.payroll.payrollIssuesConnection.edges.map((edge) => edge.node) ?? []}
      />
    </ResponsivePage.Body>
  )
}

export default observer(PayrollIssuesPage)
